import React, { useState, MouseEventHandler, useEffect } from 'react'
import { Grid, Box, Typography, IconButton, InputAdornment, Button, TextField } from '@mui/material'
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material'
import { ReCAPTCHA } from 'react-google-recaptcha'
import i18n from 'i18n/index'

import useStyles, { showPasswordIconStyles } from './style'
import REGEX_EMAIL from '../constants'
import ReCaptcha from 'components/Common/ReCaptcha'
import { localStorageKeysAnalysis } from 'constants/globals'

type Props = {
  changeUsername: (value: string) => void
  handleEnterKey: React.KeyboardEventHandler<HTMLInputElement>
  handlePassword: (password: string) => void
  handleShowForgotPassword: () => void
  error: string
  login: () => void
  credentials: {
    username: string
    password: string
  }
  captchaRef?: { current: ReCAPTCHA }
}

const FormLogin = (props: Props) => {
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)
  const { changeUsername, handleEnterKey, handlePassword, handleShowForgotPassword, error, login, credentials } = props

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.preventDefault()
  }

  const validateEmail = () => {
    return !REGEX_EMAIL.test(credentials.username)
  }

  useEffect(() => {
    localStorage.removeItem(localStorageKeysAnalysis.instrumentAnalysis)
  }, [])

  return (
    <form className="formlogin">
      <Typography id="text-header-login" variant="h1" color="text.primary" sx={{ marginBottom: 5 }}>
        {i18n.t('loginFormEnter')}
      </Typography>
      <TextField
        id="input-username-login"
        autoComplete="email"
        className={classes.width100}
        error={!!error || validateEmail()}
        color="primary"
        variant="standard"
        placeholder={''}
        label={i18n.t('loginFormUsername')}
        onChange={(event): void => {
          const { value } = event.target
          changeUsername(value)
        }}
        onKeyDown={handleEnterKey}
        helperText={validateEmail() ? 'Formato correo incorrecto' : ' '}
      />
      <Box style={{ marginBottom: 30 }} />
      <TextField
        id="input-password-login"
        autoComplete="password"
        className={classes.width100}
        error={!!error}
        color="primary"
        variant="standard"
        type={showPassword ? 'text' : 'password'}
        placeholder={''}
        label={i18n.t('loginFormPassword')}
        onChange={(event): void => {
          const { value } = event.target
          handlePassword(value)
        }}
        onKeyDown={handleEnterKey}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                className={classes.iconButton}
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword as any as MouseEventHandler<HTMLButtonElement>}
                edge="end"
              >
                {showPassword ? (
                  <VisibilityOutlined sx={showPasswordIconStyles} />
                ) : (
                  <VisibilityOffOutlined sx={showPasswordIconStyles} />
                )}
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <Typography id="text-error-login" variant="subtitle1" color="error.light">
        {error}
      </Typography>
      {localStorage.getItem('errorLogin') === 'true' ? (
        <Grid container justifyContent="flex-start" alignItems="center" style={{ marginTop: 32 }}>
          <ReCaptcha captchaRef={props?.captchaRef || null} />
        </Grid>
      ) : null}
      <Grid container justifyContent="flex-start" alignItems="center" style={{ marginTop: 32 }}>
        <Button
          id="button-login"
          variant="contained"
          size="large"
          onClick={login}
          disabled={!(credentials.password && credentials.username)}
        >
          {i18n.t('GetInto')}
        </Button>
      </Grid>
      <Box>
        <Button
          id="button-forgot-password"
          color="primary"
          size="large"
          className={classes.forgotPassword}
          onClick={handleShowForgotPassword}
        >
          ¿{i18n.t('forgotPassword')}?
        </Button>
      </Box>
    </form>
  )
}

export default FormLogin
